import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Observable, map } from 'rxjs';
import { ConciliationMonitor, ConciliationOrderDetail, ConsolidateConciliationReturn } from '../models/conciliation.model';
import { AverageState, CashState } from 'src/app/monitor-cash/monitor-cash/monitor-cash.reducer';
import { Office } from '../models/office.interface';

@Injectable({
  providedIn: 'root'
})
export class ConciliationService extends BaseService{


  constructor(private http: HttpClient) {
    super(http);
  }

  setInitialCash(data: any) {
    return super.post('Conciliation/SetInitialCash', data);
  }

  consolidate(officeId: string): Observable<ConsolidateConciliationReturn> {
    const conciliationDate = {
      conciliationDate: new Date(),
      officeId: officeId
    }
    return super.post('Conciliation/Consolidate', conciliationDate);
  }

  getOrderByCurrency(currency: string, office: Office): Observable<ConciliationOrderDetail[]> {
    let params: HttpParams = new HttpParams().set('currency', currency);

    return super.get(`Conciliation/Orders/${office.id}`, params);
  }

  registerOrder(orderId: string, register: boolean) {
    return super.patch(`Conciliation/Order/${orderId}`, register);
  }

  getCashMonitor(office: Office): Observable<ConciliationMonitor> {
    return super.get<ConciliationMonitor>(`Conciliation/Monitor/${office.id}`)
  }

  getCash(office: Office): Observable<CashState[]> {
    return super.get<ConciliationMonitor>(`Conciliation/Monitor/${office.id}`).pipe
    (
      map(e => e.currencies?.map(c =>
        <CashState>{
          currency: c.currency,
          initialValue: c.initialValue,
          value: c.value,
          projectedValue: c.projectedValue
        }
      )
      )
    )
  }

  getAverages(office: Office): Observable<AverageState[]> {
    return super.get<ConciliationMonitor>(`Conciliation/Monitor/${office.id}`).pipe
    (
      map(e => e.currencies?.map(c =>
        <AverageState>{
          currency: c.currency,
          averagePucharseValue: c.averagePucharseValue,
          averageShippingValue: c.averageShippingValue
        }
      )
      )
    )
  }
}
